import { useState, useEffect } from "react";
import Modal from "../../components/common/Modal";
import CrudForm from "../../components/common/crud/CrudForm";
import expenseMasterService from "../../services/expenseMasterService";
import expenseCategoryService from "../../services/expenseCategoryService";
import alertService from "../../utils/alertService";
import { normalizeApiError } from "../../utils/apiError";

const expenseFormSchema = [
  {
    name: "expCatId",
    label: "Expense Category",
    type: "searchable dropdown",
    placeholder: "Select category",
    validation: { required: true },
  },
  {
    name: "price",
    label: "Price",
    type: "number",
    placeholder: "0.00",
    validation: { required: true, min: 0.01 },
  },
  {
    name: "file",
    label: "Attachment",
    type: "file",
    accept: ".pdf,.jpg,.jpeg,.png",
  },
  {
    name: "remark",
    label: "Remark",
    type: "textarea",
    placeholder: "Optional remarks...",
  },
  {
    name: "isActive",
    label: "Is Active",
    type: "checkbox",
    defaultValue: true,
  },
];

function ExpenseCreateModal({ isOpen, onClose, blId, blNumber, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    if (isOpen) {
      loadCategories();
    }
  }, [isOpen]);

  const loadCategories = async () => {
    try {
      const data = await expenseCategoryService.getActiveExpenseCategories();
      setCategoryOptions(
        data.map((c) => ({
          label: c.expenseCategoryName,
          value: c.expenseCategoryId,
        }))
      );
    } catch (err) {
      console.error("Failed to load expense categories", err);
    }
  };

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await expenseMasterService.createExpense({
        ...values,
        blId: blId,
      });
      alertService.success("Expense added successfully.");
      onSuccess?.();
      onClose();
    } catch (err) {
      alertService.error(normalizeApiError(err).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Add Expense for BL: ${blNumber}`}>
      <CrudForm
        mode="create"
        schema={expenseFormSchema.map((f) => 
          f.name === "expCatId" ? { ...f, options: categoryOptions } : f
        )}
        initialValues={{ isActive: true, price: "" }}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}

export default ExpenseCreateModal;
